import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import './App.css';
import './scanner.css';

import store, { persistor } from "./redux/store";
import 'react-toastify/dist/ReactToastify.css';
import { AppRoutes } from './routes';
import { BrowserRouter } from 'react-router-dom';
import { GroupChatProvider } from './context/groupchatContext';
import PusherProvider from './context/pusherContext';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Foxit from './components/Foxit';

function App() {
  const [isOnline, setIsOnline] = useState(() => (
    typeof navigator === 'undefined' ? true : navigator.onLine
  ));

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div className="App">
      {!isOnline ? (
        <div className="internet-connection-banner" role="status" aria-live="polite">
          Internet connection lost. You are offline. Messages may not be sent or received until the connection is restored.
        </div>
      ) : null}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        bodyClassName="toastify-text-left"
      />
      <Provider store={store}>
        {/* <PersistGate persistor={persistor}> */}
          <BrowserRouter>
            <GroupChatProvider>
              <PusherProvider>
                <AppRoutes />
              </PusherProvider>
            </GroupChatProvider>
          </BrowserRouter>
        {/* </PersistGate> */}
      </Provider>
    </div>
  );
}

export default App;
